import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { DiversityEditComponent } from 'app/common/diversity/diversity-edit.component';
import { SupplierDiversity } from 'app/profile/models/onboarding.model';
import { DataWithSupplierCode, OPERATION, Supplier } from 'app/profile/models/supplier.model';
import { EventService } from 'app/profile/services/event.service';
import { SelectEventData } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { I18nService } from 'app/shared/services/i18n.service';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions';
import { Guid, validateAllFormFields, validateAllFormGroupsInArrayForm } from 'app/shared/utils/utils';
import { takeUntil } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-diversity-dialog',
  templateUrl: './diversity-dialog.component.html',
  styleUrls: ['./diversity-dialog.component.scss']
})
export class DiversityDialogComponent extends BaseComponent implements OnInit {
  supplierDiversity: SupplierDiversity;
  @ViewChild('diversityedit', { static: false }) diversityEditChild: DiversityEditComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: DataWithSupplierCode<SupplierDiversity>,
    public dialogRef: MatDialogRef<DiversityDialogComponent>,
    private store: Store<SupplierState>,
    private dialog: TslDialog,
    private eventService: EventService,
    private translate: I18nService,
    private tslToaster: TslToastrService
  ) {
    super();
    this.supplierDiversity = this.dialogData.data;

    this.store.pipe(select(SelectEventData), takeUntil(this.ngUnsubscribe)).subscribe((evt: any) => {
      if (evt) {
        this.dialogRef.close(true);
      }
    });
  }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.diversityEditChild.mainForm.valid && this.diversityEditChild.documentGrid.requiredDocumentsFormArray.valid) {
      var props = this.diversityEditChild.getEventPayload();
      if(this.uiValidation(props)){
        this.dialog.alert(this.translate.get('Error'), this.translate.get('No changes to submit!'));
      }
      else{
       this.processSave(props);
      }
    } else {
      validateAllFormFields(this.diversityEditChild.mainForm);
      if(this.diversityEditChild.documentGrid.requiredDocumentsFormArray && this.diversityEditChild.documentGrid.requiredDocumentsFormArray.length > 0)
      {
        validateAllFormGroupsInArrayForm(this.diversityEditChild.documentGrid.requiredDocumentsFormArray);
      }
    }
  }

  private uiValidation(props: Supplier){
    var diversityflag = false;
    var councilflag = false;
    var govtflag = false;
    var docflag = true;

    if(this.supplierDiversity.IsDiversityOwned != props.Diversity.IsDiversityOwned)
    {
      return false;
    }
    else {
      if(props.Diversity.IsDiversityOwned == 'Yes'){
        diversityflag = this.arraysEqual(this.supplierDiversity.DiversityTypes, props.Diversity.DiversityTypes)

        if(this.supplierDiversity.OwnershipPercentage != props.Diversity.OwnershipPercentage){
          diversityflag = false;
        }
      }
      else{
        diversityflag = true;
      }
    }

    if(this.supplierDiversity.IsCouncilCertified != props.Diversity.IsCouncilCertified){
      return false
    }
    else {
      if(props.Diversity.IsCouncilCertified == 'Yes' ){
        councilflag = this.arraysEqual(this.supplierDiversity.CouncilCertifications, props.Diversity.CouncilCertifications)
      }
      else{
        councilflag = true;
      }
    }

    if(this.supplierDiversity.IsGovtCertified != props.Diversity.IsGovtCertified){
      return false
    }
    else{
      if(props.Diversity.IsGovtCertified == 'Yes')
      {
        govtflag = this.arraysEqual(this.supplierDiversity.GovtCertifications, props.Diversity.GovtCertifications)
      }
      else{
        govtflag = true;
      }
    }

    // check if props.Documents has any new documents
    props.Documents?.forEach(element => {
      if(!element?.DocumentID){
        docflag = false;
      }
    });

    if(!this.diversityEditChild.documentGrid.requiredDocumentsFormArray.pristine){
      docflag = false;
    }
    return diversityflag && councilflag && govtflag && docflag
  }

  private objectsEqual(o1, o2)
  {
    return Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(p => o1[p] === o2[p]);
  }

  private arraysEqual(a1, a2)
  {
    if(a1 && a2){
      return a1.length === a2.length && a1.every((o, idx) => this.objectsEqual(o, a2[idx]));
    }
    else{
      return false;
    }
  }

  private processSave(props: any) {
    //submit diversity, council, government document(s)
    this.store.dispatch(new IncrementLoaderCount());
    this.eventService.PostEvent({
      Name: 'Diversity Change Requested',
      Properties: props,
      ReferenceIdentifier: this.dialogData.suppliercode
    }).subscribe(event => {
      this.store.dispatch(new DecrementLoaderCount());
      this.tslToaster.success('Success!', null, {
        duration: 5000
      })
      this.dialogRef.close(true);
    }, (error) => {
      this.store.dispatch(new DecrementLoaderCount());
      console.error(error);
      this.tslToaster.error('Something went wrong. Please try again!', null, {
        duration: 5000
      })
    })
  }

}
